const Logo = require("./logo.png");
const Square = require("./square.png");
const PdfIcon = require("./pdf-icon.png");
const ImageVector = require("./registration.png");

export { Logo, Square, PdfIcon, ImageVector };
